/* Blackheath Stamps — shared PDP interactions (all 5 designs).
   Conventions:
     [data-pdp-gallery]  wraps a stage + thumbs; [data-pdp-main] is the big image; [data-pdp-thumb] swaps it.
     [data-pdp-viewer]    wraps a tabbed viewer; [data-pdp-tab][data-view] toggles [data-pdp-view].
     [data-pdp-viewthumb][data-view]  thumbnail buttons that also switch the viewer.
     [data-pdp-acc]       accordion trigger toggling aria-controls panel.
     [data-pdp-stickyadd] submits the on-page add-to-cart form (#pdp-form).
*/
(function () {
  "use strict";

  /* ---- Gallery: thumbnail swap + zoom toggle with pointer pan ---- */
  document.querySelectorAll("[data-pdp-gallery]").forEach(function (g) {
    var main = g.querySelector("[data-pdp-main]");
    var stage = g.querySelector("[data-pdp-stage]");
    var zoomText = g.querySelector("[data-pdp-zoomtext]");
    var thumbs = g.querySelectorAll("[data-pdp-thumb]");

    function setZoom(on) {
      if (!stage || !main) return;
      stage.classList.toggle("is-zoomed", on);
      stage.setAttribute("aria-label", on ? "Stamp image zoomed — activate to zoom out" : "Stamp image — activate to zoom in");
      if (zoomText) zoomText.textContent = on ? "Click to zoom out" : "Click to zoom";
      if (!on) main.style.transformOrigin = "center center";
    }

    thumbs.forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (!main) return;
        var full = btn.getAttribute("data-full");
        if (full) main.src = full;
        var alt = btn.getAttribute("data-alt");
        if (alt) main.alt = alt;
        thumbs.forEach(function (b) {
          b.classList.remove("is-active");
          b.removeAttribute("aria-current");
        });
        btn.classList.add("is-active");
        btn.setAttribute("aria-current", "true");
        setZoom(false);
      });
    });

    if (stage && main) {
      stage.addEventListener("click", function () { setZoom(!stage.classList.contains("is-zoomed")); });
      stage.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setZoom(!stage.classList.contains("is-zoomed")); }
        if (e.key === "Escape") setZoom(false);
      });
      stage.addEventListener("mousemove", function (e) {
        if (!stage.classList.contains("is-zoomed")) return;
        var r = stage.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width) * 100;
        var y = ((e.clientY - r.top) / r.height) * 100;
        main.style.transformOrigin = x + "% " + y + "%";
      });
    }
  });

  /* ---- Tabbed viewer (Stockcard design) ---- */
  function switchView(root, view) {
    root.querySelectorAll("[data-pdp-tab]").forEach(function (t) {
      t.setAttribute("aria-selected", t.getAttribute("data-view") === view ? "true" : "false");
      t.tabIndex = t.getAttribute("data-view") === view ? 0 : -1;
    });
    root.querySelectorAll("[data-pdp-viewthumb]").forEach(function (t) {
      t.setAttribute("aria-pressed", t.getAttribute("data-view") === view ? "true" : "false");
    });
    root.querySelectorAll("[data-pdp-view]").forEach(function (p) {
      var on = p.getAttribute("data-pdp-view") === view;
      p.hidden = !on;
      p.classList.toggle("active", on);
    });
  }
  document.querySelectorAll("[data-pdp-viewer]").forEach(function (root) {
    root.querySelectorAll("[data-pdp-tab],[data-pdp-viewthumb]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        switchView(root, btn.getAttribute("data-view"));
      });
    });
  });

  /* ---- Accordions (Quick-Buy design) ---- */
  document.querySelectorAll("[data-pdp-acc]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var expanded = btn.getAttribute("aria-expanded") === "true";
      btn.setAttribute("aria-expanded", String(!expanded));
      var panel = document.getElementById(btn.getAttribute("aria-controls"));
      if (panel) panel.hidden = expanded;
    });
  });

  /* ---- Mobile sticky bar: submit the on-page form ---- */
  document.querySelectorAll("[data-pdp-stickyadd]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var form = document.getElementById("pdp-form");
      if (!form) return;
      if (form.requestSubmit) form.requestSubmit();
      else form.submit();
    });
  });
})();
